<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


  export default {
    name: 'App',
    data() {
      return{

      }
    },
    methods:{


    },
    mounted() {


    }

  }
</script>

<style>

  @import "./assets/css/main.css";
   @import "./assets/css/color-dark.css";



</style>
